module.exports = __webpack_public_path__ + "media/content-creator/mobile-beauty-2-58079d35.png";